import { useState } from 'react';
import { createModel } from 'hox';
import { enquiryService } from '../../dtpService';
import { IDtpMaterialDetail, IDtpDetail } from '../../dtpTypes';
import { IMaterialDetail } from '@/views/base/material/materialService';
import { message } from 'antd';
import useGlobalModel from '@/model/globalModel';
import { useLockFn } from 'ahooks';
import { convertRes2Blob } from '@/utils/exportFile';
import moment from 'moment';
import { IFileInfo, publicService } from '@/views/public/publicService';
import { momentFormat } from '@/utils/utils';

export const useDtpDetailModel = createModel(function () {
	const {
		user: { shopCode, shopName },
		setLoadingInfo,
	} = useGlobalModel(({ user }) => [user]);
	const initFormVal = {
		id: '',
		code: '',
		// warningStatus: "0",
		shopName,
	} as IDtpDetail;

	//编辑缓存
	const [editFormVal, setEditFormVal] = useState<IDtpDetail>(initFormVal);
	const [editList, setEditList] = useState<IFileInfo[]>([]);

	//新增缓存
	const [addFormVal, setAddFormVal] = useState<IDtpDetail>(initFormVal);
	const [addList, setAddList] = useState<IFileInfo[]>([]);

	// 文件列表显示控制
	const [fileVisible, setFileVisible] = useState<boolean>(false);

	//重置页面缓存
	const resetPageCache = (mode: string) => {
		if (mode === 'edit') {
			setEditFormVal(initFormVal);
			setEditList([]);
		} else if (mode === 'add') {
			setAddFormVal(initFormVal);
			setAddList([]);
		}
	};

	//主单修改
	const updateFormVal = (mode: string, val?: object | null) => {
		const setFormVal = mode === 'edit' ? setEditFormVal : setAddFormVal;
		setFormVal((origin: any) => (val ? { ...origin, ...val } : initFormVal));
	};

	//获取一条数据
	const getDtpDetailOne = async (id: string) => {
		let { retData } = await enquiryService.one(id);
		let { ...formVal } = retData;
		if (retData) {
			setEditFormVal({
				...formVal,
				signingTime: (formVal.signingTime ? moment(formVal.signingTime) : null) as any,
				expireTime: (formVal.expireTime ? moment(formVal.expireTime) : null) as any,
				createTime: momentFormat(formVal.createTime),
				updateTime: momentFormat(formVal.updateTime)
				// warningStatus:formVal?.warningStatus ? (formVal?.warningStatus === 1 ? '否' : "是") : ''
			});
		}
		return retData;
	};

	//报价单新增 | 编辑
	const insertOrUpdateDtp = useLockFn(async (mode: string, formVal: IDtpDetail) => {
		const materialList = mode === 'edit' ? editList : addList;
		let data = {
			...formVal,
			signingTime: formVal.signingTime
				? moment(formVal.signingTime).format('YYYY-MM-DD HH:mm:ss')
				: '',
			expireTime: formVal.expireTime
				? moment(formVal.expireTime).format('YYYY-MM-DD HH:mm:ss')
				: '',
			shopCode,
			shopName,
			details: materialList,
		};
		//新增
		if (mode === 'edit') {
			let { retData } = await enquiryService.update({
				...data,
				id: editFormVal.id,
				code: editFormVal.code ?? '',
			});
			getDtpDetailOne(editFormVal.id);
			message.success('保存成功');
			return retData;
		} else {
			let { retData } = await enquiryService.insert(data);
			message.success('新增成功,自动转换至编辑详情页');
			return retData;
		}
	});

	//导出
	const exportDtp = async () => {
		setLoadingInfo({ loadingVisible: true, txt: '快速导出中' });
		try {
			// let result = await enquiryService.detailExport(editFormVal.code, shopCode);
			// result && setLoadingInfo({ loadingVisible: false, txt: "" });
			// convertRes2Blob(result);
		} catch {
			setLoadingInfo({ loadingVisible: false, txt: '' });
		}
	};

	return {
		/***field***/
		editFormVal,
		editList,
		addFormVal,
		addList,
		fileVisible,
		/***method***/
		getDtpDetailOne,
		updateFormVal,
		insertOrUpdateDtp,
		resetPageCache,
		exportDtp,
		setFileVisible
	};
});
